import React, { useState } from 'react';
import { Menu, ShoppingCart, Search, X } from 'lucide-react';
import NotificationBell from '../common/NotificationBell';
import SearchBar from '../search/SearchBar';

const MobileNavbar = ({ user, cartItemCount = 0, onMenuClick, onCartClick }) => {
  const isBusinessUser = user?.role === 'business';
  const [searchOpen, setSearchOpen] = useState(false);

  return (
    <div className="fixed top-0 left-0 right-0 bg-white border-b border-gray-200 z-40 lg:hidden">
      <div className="flex items-center justify-between px-4 py-3">
        {/* Left: Menu Button */}
        <button
          onClick={onMenuClick}
          className="p-2 hover:bg-gray-100 rounded-lg transition-colors"
          aria-label="Open menu"
        >
          <Menu className="w-6 h-6 text-gray-700" />
        </button>

        {/* Center: Logo */}
        <div className="flex-1 text-center">
          <span className="text-xl font-bold text-blue-600">WholesaleHub</span>
        </div>

        {/* Right: Action Icons */}
        <div className="flex items-center gap-1">
          {/* Search Icon — only for business users */}
          {isBusinessUser && (
            <button
              onClick={() => setSearchOpen(!searchOpen)}
              className="p-2 hover:bg-gray-100 rounded-lg transition-colors"
              aria-label="Search products"
            >
              {searchOpen ? <X className="w-6 h-6 text-gray-700" /> : <Search className="w-6 h-6 text-gray-700" />}
            </button>
          )}

          {/* Notification Bell */}
          <NotificationBell />

          {/* Cart Icon — only for business users */}
          {isBusinessUser && (
            <button
              onClick={onCartClick}
              className="relative p-2 hover:bg-gray-100 rounded-lg transition-colors"
              aria-label="View cart"
            >
              <ShoppingCart className="w-6 h-6 text-gray-700" />
              {cartItemCount > 0 && (
                <span className="absolute top-0 right-0 bg-red-500 text-white text-xs font-bold rounded-full w-5 h-5 flex items-center justify-center">
                  {cartItemCount > 9 ? '9+' : cartItemCount}
                </span>
              )}
            </button>
          )}
        </div>
      </div>

      {/* Mobile Search Bar — slides open below navbar */}
      {isBusinessUser && searchOpen && (
        <div className="px-4 pb-3 border-t border-gray-100">
          <SearchBar mobile onClose={() => setSearchOpen(false)} />
        </div>
      )}
    </div>
  );
};

export default MobileNavbar;